import React from "react";
import DesignationStep from "./Steps/DesignationStep";
import SalaryStep from "./Steps/SalaryStep";
import TimelineStep from "./Steps/TimelineStep";
import LocationStep from "./Steps/LocationStep";
import KnownForStep from "./Steps/KnownForStep";
import FutureNoteStep from "./Steps/FutureNoteStep";

const FutureYou = ({
  userFutureData,
  onInputChange,
  subStep,
  essentialsField,
  futureVoiceNote,
  currentKnownForInput,
  onCurrentKnownForInputChange,
  onEnterNext,
  onFutureVoiceUpload,
  uploading,
  onRecordingChange, // NEW
}) => {
  if (subStep === 1) {
    const essentialFields = [
      { id: "designation", component: DesignationStep },
      { id: "salary", component: SalaryStep },
      { id: "timeline", component: TimelineStep },
      { id: "location", component: LocationStep },
    ];

    const currentField = essentialFields[essentialsField];
    const Component = currentField.component;

    return (
      <Component
        value={userFutureData[currentField.id]}
        onChange={(value) => onInputChange(currentField.id, value)}
        onEnterNext={onEnterNext}
      />
    );
  }

  if (subStep === 2) {
    return (
      <KnownForStep
        knownFor={userFutureData.knownFor || []}
        onChange={(value) => onInputChange("knownFor", value)}
        currentInput={currentKnownForInput}
        onCurrentInputChange={onCurrentKnownForInputChange}
      />
    );
  }

  if (subStep === 3) {
    return (
      <FutureNoteStep
        futureVoiceNote={futureVoiceNote}
        onVoiceUpload={onFutureVoiceUpload}
        uploading={uploading}
        onRecordingChange={onRecordingChange} 
      />
    );
  }

  return null;
};

export default FutureYou;